import RegisterUser from "../Components/Auth/register";

export default function RegisterPage() {
  return <RegisterUser />;
}
